module.exports = __webpack_public_path__ + "media/images/markers/mobile-2e86feda514834f36c7dea0b2bd346db.png";